import React from "react";

import { Stack, Typography } from "@mui/material";

import SettingAlert from "@app/analytics/account/components/SettingAlert";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

type MigrateMeetingsConfirmationModal = Pick<
  ConfirmationModalProps,
  "loading" | "open" | "onClose" | "onConfirm"
>;

const MigrateMeetingsConfirmationModal = (
  props: MigrateMeetingsConfirmationModal
) => (
  <ConfirmationModal
    {...props}
    title="Migrate Meetings"
    confirmProps={{ label: "Yes, migrate meetings" }}
    cancelProps={{ label: "Not now" }}
    size="720px"
  >
    <Stack direction="column" spacing={2}>
      <Typography variant="bodyPrimaryReg">
        Would you like to migrate meetings measured with Read to this Workspace?
      </Typography>
      <Typography variant="bodyPrimaryReg">
        Because you’re an existing Read user, you can choose to migrate your
        past meetings into this Workspace. Associating meetings with a Workspace
        unlocks more robust trends and insights, and allows you to compare your
        performance for those meetings against team members.
      </Typography>
      <SettingAlert severity="info" show persist>
        Once you migrate your meetings, they will only be accessible under the
        Workspace.
      </SettingAlert>
    </Stack>
  </ConfirmationModal>
);

export default MigrateMeetingsConfirmationModal;
